export const hamburgerIcon = '/icons/hamburger.svg';
export const cartIcon = '/icons/cart.svg';
export const searchIcon = '/icons/search.svg';
export const searchIconDark = '/icons/search-dark.svg';
export const arrowUpIcon = '/icons/arrow-up.svg';
export const arrowDownIcon = '/icons/arrow-down.svg';
export const arrowIcon = '/icons/arrow-down-white.svg';
export const arrowRightIcon = '/icons/arrow-right.svg';
export const xIcon = '/icons/x.svg';
export const chevronLeftIcon = '/icons/chevron-left.svg';
export const deliveryIcon = '/icons/delivery.svg';
export const licensePlateIcon = '/icons/license-plate-flag.svg';
export const loadingIcon = '/icons/loading.svg';
export const loadingLightIcon = '/icons/loading-light.svg';
export const packageIcon = '/icons/package.svg';
export const qualityIcon = '/icons/quality.svg';
export const tagIcon = '/icons/tag.svg';
